export interface AccessTokenPayload {
  emails: string[];
  exp: number;
  iat: number;
  iss: string;
  rsub: string;
  sessionHandle: string;
  "st-ev"?: { v: boolean; t: number };
  sub: string;
  tId: string;
  // Optional (only available for quick reply tokens)
  entityId?: string;
  projectId?: string;
  // Perhaps there are more fields
}

export function parseAccessTokenPayload(token: string | undefined): AccessTokenPayload | undefined {
  if (!token) {
    return;
  }

  try {
    const base64Payload = token.split(".")[1];
    if (base64Payload === undefined) {
      throw new Error("Invalid token format");
    }

    const payload = base64UrlDecode(base64Payload);

    return JSON.parse(payload.toString());
  } catch (err) {
    console.error("Error parsing access token payload:", err);
  }
}

function base64UrlDecode(str: string) {
  let output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }

  try {
    return b64DecodeUnicode(output);
  } catch (err) {
    console.error("Error decoding base64 string:", err);
    throw err;
  }
}

function b64DecodeUnicode(str: string) {
  return decodeURIComponent(
    atob(str).replace(/(.)/g, (_m, p) => {
      let code = (p as string).charCodeAt(0).toString(16).toUpperCase();
      if (code.length < 2) {
        code = "0" + code;
      }

      return "%" + code;
    }),
  );
}
